export default {
	// 获取登录状态
	loginType(_this) {
		_this.user = _this.$store.state.user;
		if (_this.$store.state.user) {
			if (_this.user.token == "") {
				_this.login = true;
			} else {
				_this.login = false;
			}
		}
	},
	// 获取头尾公共信息
	getCommonInfo(_this, callback) {
		let common_info = _this.$store.state.common_info;
		// console.log(common_info)

		if (common_info) {
			_this.common_info = common_info;
			if (callback) {
				callback();
			}
		} else {
			_this.$api.common().then((res) => {
				if (res.code == 0) {
					_this.$store.commit("commonInfo", res.data);
					_this.common_info = res.data;
					if (callback) {
						callback();
					}
				}
			}).catch((err) => {
				this.message(_this, err)
			});
		}
	},
	// 进入个人中心
	toPersonal(_this) {
		_this.user = _this.$store.state.user;
		if (_this.$store.state.user) {
			if (_this.user.token != "") {
				_this.$router.push("/ttshop_user");
			} else {
				_this.$router.push("/signin");
			}
		} else {
			_this.$router.push("/signin");
		}
	},
	// 退出登录
	signout(_this) {
		window.localStorage.removeItem('userInfo');
		_this.$store.commit("userInfo", '');
		_this.user = "";
		_this.login = true;
		_this.$router.push("/");
		window.location.reload();
	},
	// 报错信息提示
	message(_this, error, callback) {
		_this.$loading().close();
		if (error.msg) {
			_this.$message({
				showClose: true,
				message: error.msg,
				type: "warning",
				offset: 200,
				duration: 1000,
			});
		}
		if (callback) {
			callback();
		}
	},
	// 页面返回顶部
	backTop(time) {
		if (!time) {
			time = 5;
		}
		let timeFun = setInterval(() => {
			let scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
			let ispeed = Math.floor(-scroll_top / 5);
			document.documentElement.scrollTop = document.body.scrollTop = scroll_top + ispeed;
			// this.isTop = true;
			if (scroll_top === 0) {
				clearInterval(timeFun);
			}
		}, time)
	},
	// 获取企业采购登录状态
	qycgloginType(_this) {
		_this.qycg_user = _this.$store.state.qycg_user;
		if (_this.$store.state.qycg_user) {
			if (_this.qycg_user.token == "") {
				_this.login = false;
			} else {
				_this.login = true;
			}
		}
	},
	qycgrouter(_this) {
		let param = ''
		let pur = _this.$route.params.route_url
		let act = _this.$route.params.act_key

		if (pur) {
			param += '/' + pur
		}
		if (act) {
			param += '/' + act
		}
		return param

	},
}